module.exports = __webpack_public_path__ + "static/media/glass_show3.4adfbb82.png";